import { decode, encode } from 'js-base64';
export const encodeBase64 = encode;
export const decodeBase64 = decode;
export const encodeObjBase64 = (d: object) =>
  encodeBase64(JSON.stringify(d, null, 0));
export const decodeObjBase64 = <T>(d: string) =>
  JSON.parse(decodeBase64(d)) as T;
